import * as AlertDialog from "@radix-ui/react-alert-dialog";
import type { ReactNode } from "react";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "default" | "danger";
  onConfirm: () => void;
  confirmDisabled?: boolean;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Bestätigen",
  cancelLabel = "Abbrechen",
  variant = "default",
  onConfirm,
  confirmDisabled = false,
}: Props) {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-overlay bg-overlay animate-fade-in" />
        <AlertDialog.Content className="fixed left-1/2 top-1/2 z-modal w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-md border border-border-primary bg-bg-elevated shadow-overlay animate-fade-in">
          <div className="border-b border-border-primary px-5 py-3">
            <AlertDialog.Title className="font-medium text-text-primary">
              {title}
            </AlertDialog.Title>
          </div>
          <AlertDialog.Description asChild>
            <div className="px-5 py-4 text-sm text-text-secondary">
              {description}
            </div>
          </AlertDialog.Description>
          <div className="flex justify-end gap-2 border-t border-border-primary bg-bg-secondary px-5 py-3">
            <AlertDialog.Cancel asChild>
              <button
                type="button"
                className="rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm font-medium text-text-primary hover:bg-bg-hover"
              >
                {cancelLabel}
              </button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <button
                type="button"
                onClick={onConfirm}
                disabled={confirmDisabled}
                className={`rounded-md px-3 py-1.5 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed ${
                  variant === "danger"
                    ? "bg-danger text-text-inverse hover:opacity-90"
                    : "bg-accent text-text-on-accent hover:bg-accent-hover"
                }`}
              >
                {confirmLabel}
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
